import { createContext, type RefObject, useContext } from 'react';

import type { SwimlanePrivateApi } from './types';

export const SwimlanePrivateApiContext = createContext<unknown>(undefined);

SwimlanePrivateApiContext.displayName = 'SwimlanePrivateApiContext';

export function useSwimlanePrivateApi(): RefObject<SwimlanePrivateApi> {
  const privateApiRef = useContext(SwimlanePrivateApiContext);

  if (privateApiRef === undefined) {
    throw new Error(
      [
        'Swimlane: Could not find the private API context.',
        'It looks like you rendered your component outside of a Swimlane parent component.',
        'This can also happen if you are bundling multiple versions of the swimlane.',
      ].join('\n'),
    );
  }

  return privateApiRef as RefObject<SwimlanePrivateApi>;
}
